<template>
  <footer>
    <hr>
    <p>Thank you for visiting my website. Please feel free to <A href="http://jp.senescence.info/contact.php">contact me</A> if you have any questions, ideas, comments or suggestions.</p>

    <p>Copyright &#169 2003 - 2013, 2015, 2018 by <a href="http://jp.senescence.info">Jo&#227o Pedro de Magalh&#227es</a>, website developed by Zoya Farooq. All rights reserved.</p>

  </footer>
</template>

<script>
export default {

}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>




// WEBPACK FOOTER //
// src/components/AppFooter.vue